<div class="db-page" [class.db-page--no-move]="!allowMove">
  <!-- Fondo decorativo: fijo al viewport, detras de todo (cabecera, tarjeta vacia,
       widgets), para que se note tambien cuando el dashboard ya tiene contenido. -->
  <mat-icon class="db-page__watermark" aria-hidden="true">insights</mat-icon>

  <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

  <div class="db-header">
    <div class="db-header__left">
      <button
        type="button"
        class="db-header__back"
        (click)="backClick.emit()"
        aria-label="Volver a áreas"
        matTooltip="Volver a áreas"
        matTooltipShowDelay="400">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="db-header__title-block">
        <!-- Migas de pan del área encima del título (las pone el dashboard del usuario) -->
        <ng-content select="[dbBreadcrumb]"></ng-content>
        <h2 class="db-header__title">{{ areaName || 'Dashboard' }}</h2>
      </div>
    </div>

    <div class="db-header__actions">
      <!-- Añadir widget: texto visible en desktop, icono solo en móvil. -->
      <button
        *ngIf="allowCreate"
        type="button"
        mat-raised-button
        class="header-button button-text blue-header-button"
        (click)="addWidgetClick.emit()"
        [disabled]="loading || !dashboardId"
        aria-label="Añadir widget"
        matTooltip="Añadir widget"
        matTooltipShowDelay="600">
        <mat-icon class="header-button-icon">add</mat-icon>
        <span class="btn-label hide-on-mobile">Añadir widget</span>
      </button>

      <!-- Configuración: icono visible en desktop y en móvil (ya no hay menú ⋮) -->
      <button
        type="button"
        mat-icon-button
        class="db-header__more-actions"
        (click)="areaInfoClick.emit()"
        aria-label="Ver Área"
        matTooltip="Ver Área"
        matTooltipShowDelay="400">
        <mat-icon>settings</mat-icon>
      </button>
    </div>
  </div>

  <!-- Estado vacío: solo en modo vista sin widgets. Ficha compacta, arriba a la
       izquierda, del tamaño aproximado de un widget - no centrada en toda la
       pantalla - para que se lea como "aqui va tu primer widget". -->
  <div class="empty-state" *ngIf="isEmptyState">
    <button
      *ngIf="mode === 'admin' && allowCreate"
      type="button"
      class="empty-state__card empty-state__card--clickable"
      (click)="addWidgetClick.emit()"
      [disabled]="!dashboardId">
      <div class="empty-state__icon" aria-hidden="true">
        <mat-icon>dashboard</mat-icon>
      </div>
      <span class="empty-state__cta-label">
        <mat-icon class="empty-state__cta-icon">add</mat-icon>
        Añadir widget
      </span>
    </button>
    <div class="empty-state__card" *ngIf="!(mode === 'admin' && allowCreate)">
      <div class="empty-state__icon" aria-hidden="true">
        <mat-icon>dashboard</mat-icon>
      </div>
      <p class="empty-state__title">Sin widgets</p>
    </div>
  </div>

  <!-- Grid gridster -->
  <div class="db-grid-shell" [class.db-grid-shell--editing]="showGridBackdrop"
       [style.--grid-cols]="cols"
       *ngIf="!loading && (gridItems.length > 0 || showGridBackdrop)">
    <gridster class="db-gridster" [options]="gridsterOptions">
      <gridster-item *ngFor="let item of gridItems; trackBy: trackByWidgetId" [item]="item">

        <!-- Estado sin entradas configuradas -->
        <ng-container *ngIf="hasNoEntries(item)">
          <div class="widget-no-device-card">
            <div class="widget-no-device-card__header">
              <div class="widget-no-device-card__title-row">
                <button
                  type="button"
                  class="widget-drag-handle widget-no-device-card__drag"
                  [class.widget-drag-handle--active]="showGridBackdrop"
                  mat-icon-button
                  aria-label="Mover widget"
                  matTooltip="Mover widget"
                  matTooltipShowDelay="400">
                  <mat-icon>drag_indicator</mat-icon>
                </button>
                <span
                  class="widget-no-device-card__title"
                  [matTooltip]="item.widget.title"
                  matTooltipShowDelay="600"
                  matTooltipPosition="above">
                  {{ item.widget.title }}
                </span>
              </div>
              <span
                *ngIf="mode === 'admin'"
                class="widget-no-device-card__preview"
                matTooltip="Widget definido desde la plantilla del administrador">
                Plantilla
              </span>
              <button
                class="widget-no-device-card__menu"
                mat-icon-button
                [matMenuTriggerFor]="noEntriesMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #noEntriesMenu="matMenu">
                <button mat-menu-item (click)="editWidgetClick.emit(item)">Editar widget</button>
                <button *ngIf="allowDelete" mat-menu-item class="menu-delete" (click)="removeWidgetClick.emit(item)">Eliminar widget</button>
              </mat-menu>
            </div>
            <div class="widget-no-device-card__body">
              <div class="no-device-mark" aria-hidden="true">
                <mat-icon class="no-device-icon">input</mat-icon>
              </div>
              <div class="no-device-copy">
                <p class="no-device-title">Sin entradas configuradas</p>
                <p class="no-device-subtitle">Edita el widget para añadir entradas de datos.</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Estado sin dispositivos sincronizados (solo usuario) -->
        <ng-container *ngIf="!hasNoEntries(item) && hasNoSyncedDevices(item)">
          <div class="widget-no-device-card">
            <div class="widget-no-device-card__header">
              <div class="widget-no-device-card__title-row">
                <button
                  type="button"
                  class="widget-drag-handle widget-no-device-card__drag"
                  [class.widget-drag-handle--active]="showGridBackdrop"
                  mat-icon-button
                  aria-label="Mover widget"
                  matTooltip="Mover widget"
                  matTooltipShowDelay="400">
                  <mat-icon>drag_indicator</mat-icon>
                </button>
                <span
                  class="widget-no-device-card__title"
                  [matTooltip]="item.widget.title"
                  matTooltipShowDelay="600"
                  matTooltipPosition="above">
                  {{ item.widget.title }}
                </span>
              </div>
              <span
                *ngIf="mode === 'admin'"
                class="widget-no-device-card__preview"
                matTooltip="Widget definido desde la plantilla del administrador">
                Plantilla
              </span>
              <button
                class="widget-no-device-card__menu"
                mat-icon-button
                [matMenuTriggerFor]="noSyncMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #noSyncMenu="matMenu">
                <button mat-menu-item (click)="editWidgetClick.emit(item)">Editar widget</button>
                <button *ngIf="allowDelete" mat-menu-item class="menu-delete" (click)="removeWidgetClick.emit(item)">Eliminar widget</button>
              </mat-menu>
            </div>
            <div class="widget-no-device-card__body">
              <div class="no-device-mark" aria-hidden="true">
                <mat-icon class="no-device-icon">sync_problem</mat-icon>
              </div>
              <div class="no-device-copy">
                <p class="no-device-title">No hay dispositivos sincronizados</p>
                <p class="no-device-subtitle">Añade o sincroniza entradas para empezar a ver datos.</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Estado sin dispositivo (solo usuario) -->
        <ng-container *ngIf="!hasNoEntries(item) && !hasNoSyncedDevices(item) && hasNoDevice(item)">
          <div class="widget-no-device-card">
            <div class="widget-no-device-card__header">
              <div class="widget-no-device-card__title-row">
                <button
                  type="button"
                  class="widget-drag-handle widget-no-device-card__drag"
                  [class.widget-drag-handle--active]="showGridBackdrop"
                  mat-icon-button
                  aria-label="Mover widget"
                  matTooltip="Mover widget"
                  matTooltipShowDelay="400">
                  <mat-icon>drag_indicator</mat-icon>
                </button>
                <span
                  class="widget-no-device-card__title"
                  [matTooltip]="item.widget.title"
                  matTooltipShowDelay="600"
                  matTooltipPosition="above">
                  {{ item.widget.title }}
                </span>
              </div>
              <span
                *ngIf="mode === 'admin'"
                class="widget-no-device-card__preview"
                matTooltip="Widget definido desde la plantilla del administrador">
                Plantilla
              </span>
              <button
                class="widget-no-device-card__menu"
                mat-icon-button
                [matMenuTriggerFor]="noDevMenu"
                (click)="$event.stopPropagation()">
                <mat-icon>more_vert</mat-icon>
              </button>
              <mat-menu #noDevMenu="matMenu">
                <button mat-menu-item (click)="editWidgetClick.emit(item)">Editar widget</button>
                <button *ngIf="allowDelete" mat-menu-item class="menu-delete" (click)="removeWidgetClick.emit(item)">Eliminar widget</button>
              </mat-menu>
            </div>
            <div class="widget-no-device-card__body">
              <div class="no-device-mark" aria-hidden="true">
                <mat-icon class="no-device-icon">{{ getNoDeviceIcon(item) }}</mat-icon>
              </div>
              <div class="no-device-copy">
                <p class="no-device-title">Dispositivo pendiente</p>
                <p class="no-device-subtitle">Asigna una fuente para mostrar datos</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Widget normal -->
        <ng-container *ngIf="!hasNoEntries(item) && !hasNoSyncedDevices(item) && !hasNoDevice(item)">
          <ng-container [ngSwitch]="item.widget.widgetType">

            <app-widget-number
              *ngSwitchCase="'NUMBER'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [displayType]="'NUMBER'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-number>

            <app-widget-number
              *ngSwitchCase="'GAUGE'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [displayType]="'GAUGE'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-number>

            <app-widget-line-chart
              *ngSwitchCase="'LINE'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-line-chart>

            <app-widget-line-chart
              *ngSwitchCase="'AREA'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-line-chart>

            <app-widget-bar-chart
              *ngSwitchCase="'BAR'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-bar-chart>

            <app-widget-device-list
              *ngSwitchCase="'DEVICE_LIST'"
              [widget]="asRenderableWidget(item)"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [typeLabel]="getWidgetTypeLabel(item.widget)"
              [sourceLabel]="getFirstSource(item.widget)"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-device-list>

            <app-widget-map
              *ngSwitchCase="'MAP'"
              [widget]="item.widget"
              [showChrome]="true"
              [isEditable]="true"
              [canDelete]="allowDelete"
              [isEditMode]="isEditMode"
              [isMockPreview]="mode === 'admin'"
              [sensorTypeLabels]="getSensorTypeLabels(item.widget)"
              (edit)="editWidgetClick.emit(item)"
              (remove)="removeWidgetClick.emit(item)">
            </app-widget-map>

            <div *ngSwitchDefault class="widget-card-default">
              <span>{{ item.widget.title }}</span>
            </div>

          </ng-container>
        </ng-container>

      </gridster-item>
    </gridster>
  </div>
</div>
